import styles from './PlacingOrderButtons.module.scss';
import cn from 'classnames';
import { Button } from '@components/Button';
import { IPlacingOrderButton, IPlacingOrderButtonsProps } from './types';

const PlacingOrderButtons: React.FC<IPlacingOrderButtonsProps> = (props: IPlacingOrderButtonsProps): React.ReactElement => {
  const { buttons, reverse } = props;

  return (
      <div className={cn(styles.actions, !reverse && styles.actionsRight)}>
        {buttons.map((item: IPlacingOrderButton, index: number) => (
            <div key={index}>
              <Button
                  disabled={item.disabled}
                  onClick={item.action}
                  pending={item.pending}
                  title={item.text}
                  type={item.type}
              />
            </div>
        ))}
      </div>
  );
};

export default PlacingOrderButtons;